export default "/048cb1f2b29308e18768c65cfd51e426596a830c/b552ae94a3baa9664c4076d726380c66.svg";